import {
  createListAllQuery,
  getOption,
  GetOptionQuery,
  GetOptionQueryVariables,
  graphqlCall,
  listOptions,
  ListOptionsQuery,
  ListOptionsQueryVariables,
  Option,
} from '@akin-home/amplify';
import { optionGraphqlToModel } from '@akin-home/options';

export const listOptionsQuery = (params: ListOptionsQueryVariables) =>
  graphqlCall<ListOptionsQuery>(listOptions, params);

export const listAllOptionsQuery = createListAllQuery<
  Option,
  ListOptionsQueryVariables
>(listOptions, 'listOptions');

export const listAllOptionModels = async (params?: ListOptionsQueryVariables) => {
  return (await listAllOptionsQuery(params)).map(optionGraphqlToModel);
};

export const getOptionQuery = (params: GetOptionQueryVariables) =>
  graphqlCall<GetOptionQuery>(getOption, params);
